import {
  createEventRoles,
  listEventRoles,
  destroyEventRoles,
  partialUpdateUser,
  User,
  EventRole,
  PatchedUserRequest
} from '@goldcast/api/backend';

export interface CheckInStaffInput {
  email: string;
  firstName: string;
  lastName: string;
}

const actions = {
  addCheckInStaff({ rootState }, { firstName, lastName, email }: CheckInStaffInput) {
    const eventId: string = rootState.studioEventList.currentEventId;
    const payload = {
      event: eventId,
      role: 8,
      user: { first_name: firstName, last_name: lastName, email: email }
    };
    return createEventRoles({ body: payload });
  },
  fetchCheckInStaff({ dispatch, commit }, { eventId, hardRefresh }: { eventId: string; hardRefresh: boolean }) {
    if (hardRefresh) {
      commit('setIsLoadingCheckInStaff', true);
    }

    return listEventRoles({ queryParams: { offset: 0, role: 8, event: eventId } })
      .then(data => {
        const checkInStaffData = data as EventRole[];
        const checkInStaffMap = checkInStaffData.reduce((acc, checkInStaff) => {
          acc[checkInStaff.id] = checkInStaff;
          return acc;
        }, {});
        commit('setCheckInStaff', checkInStaffMap);

        if (hardRefresh) {
          commit('setIsLoadingCheckInStaff', false);
        }
      })
      .catch(() => {
        dispatch(
          'studioToast/triggerToast',
          { msg: 'Error loading Check-in Staff! Please Try Again.', mode: 'error' },
          { root: true }
        );

        if (hardRefresh) {
          commit('setIsLoadingCheckInStaff', false);
        }
      });
  },
  updateCheckInStaff({ state, commit, rootGetters }, { checkInStaffId, user }: { checkInStaffId: number; user: User }) {
    const userId = state.checkInStaff[checkInStaffId].user.id;
    const eventId = rootGetters['studioEventList/getCurrentEvent'].id;
    const payload = {
      ...user,
      org_user: {
        event: eventId,
        org_user_data: user
      }
    } as PatchedUserRequest;
    return partialUpdateUser({ id: userId, body: payload }).then(updatedUser => {
      commit('updateCheckInStaff', {
        checkInStaffId,
        updatedCheckInStaffUser: updatedUser
      });
    });
  },
  deleteCheckInStaff({ commit }, checkInStaffId: number) {
    return destroyEventRoles({ id: checkInStaffId }).then(() => {
      commit('deleteCheckInStaff', checkInStaffId);
    });
  }
};

export default actions;
